import _defineProperty from "/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import "./main.css";
import { Item as $ee97ea796309b076$re_export$Item, Section as $ee97ea796309b076$re_export$Section } from "@react-stately/collections";
import $j8tbs$react, { useMemo as $j8tbs$useMemo, useContext as $j8tbs$useContext, useRef as $j8tbs$useRef, Fragment as $j8tbs$Fragment } from "react";
import { useDOMRef as $j8tbs$useDOMRef, useStyleProps as $j8tbs$useStyleProps, classNames as $j8tbs$classNames, ClearSlots as $j8tbs$ClearSlots, SlotProvider as $j8tbs$SlotProvider } from "@react-spectrum/utils";
import { useListState as $j8tbs$useListState } from "@react-stately/list";
import { useListBox as $j8tbs$useListBox, useOption as $j8tbs$useOption, useListBoxSection as $j8tbs$useListBoxSection } from "@react-aria/listbox";
import { FocusScope as $j8tbs$FocusScope, FocusRing as $j8tbs$FocusRing } from "@react-aria/focus";
import { ListLayout as $j8tbs$ListLayout } from "@react-stately/layout";
import { mergeProps as $j8tbs$mergeProps } from "@react-aria/utils";
import { ProgressCircle as $j8tbs$ProgressCircle } from "@react-spectrum/progress";
import { useCollator as $j8tbs$useCollator, useLocalizedStringFormatter as $j8tbs$useLocalizedStringFormatter, useLocale as $j8tbs$useLocale } from "@react-aria/i18n";
import { useProvider as $j8tbs$useProvider } from "@react-spectrum/provider";
import { VirtualizerItem as $j8tbs$VirtualizerItem, Virtualizer as $j8tbs$Virtualizer, useVirtualizerItem as $j8tbs$useVirtualizerItem, layoutInfoToStyle as $j8tbs$layoutInfoToStyle } from "@react-aria/virtualizer";
import $j8tbs$spectrumiconsuiCheckmarkMedium from "@spectrum-icons/ui/CheckmarkMedium";
import { Grid as $j8tbs$Grid } from "@react-spectrum/layout";
import { useHover as $j8tbs$useHover, isFocusVisible as $j8tbs$isFocusVisible } from "@react-aria/interactions";
import { Text as $j8tbs$Text } from "@react-spectrum/text";
import { useSeparator as $j8tbs$useSeparator } from "@react-aria/separator";
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}
var $07d5971c39cb246a$exports = {};
var $067dbd0c037ad155$exports = {};
$067dbd0c037ad155$exports = {
  "loading": "\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u062D\u0645\u064A\u0644...",
  "loadingMore": "\u062C\u0627\u0631\u064D \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0645\u0632\u064A\u062F..."
};
var $6ee4da2747de1e02$exports = {};
$6ee4da2747de1e02$exports = {
  "loading": "\u0417\u0430\u0440\u0435\u0436\u0434\u0430\u043D\u0435...",
  "loadingMore": "\u0417\u0430\u0440\u0435\u0436\u0434\u0430\u043D\u0435 \u043D\u0430 \u043E\u0449\u0435..."
};
var $b58a7d965b7aa1b3$exports = {};
$b58a7d965b7aa1b3$exports = {
  "loading": "Na\u010D\xEDt\xE1n\xED...",
  "loadingMore": "Na\u010D\xEDt\xE1n\xED dal\u0161\xEDch..."
};
var $ecaca51f024191b0$exports = {};
$ecaca51f024191b0$exports = {
  "loading": "Indl\xE6ser ...",
  "loadingMore": "Indl\xE6ser flere ..."
};
var $6e434aa373f128b4$exports = {};
$6e434aa373f128b4$exports = {
  "loading": "Laden...",
  "loadingMore": "Mehr laden ..."
};
var $ddbe45fb199df913$exports = {};
$ddbe45fb199df913$exports = {
  "loading": "\u03A6\u03CC\u03C1\u03C4\u03C9\u03C3\u03B7...",
  "loadingMore": "\u03A6\u03CC\u03C1\u03C4\u03C9\u03C3\u03B7 \u03C0\u03B5\u03C1\u03B9\u03C3\u03C3\u03CC\u03C4\u03B5\u03C1\u03C9\u03BD..."
};
var $2083b83b84266bb4$exports = {};
$2083b83b84266bb4$exports = {
  "loading": "Loading\u2026",
  "loadingMore": "Loading more\u2026"
};
var $a41434a97f5222d7$exports = {};
$a41434a97f5222d7$exports = {
  "loading": "Cargando\u2026",
  "loadingMore": "Cargando m\xE1s\u2026"
};
var $0a1b42c97638052f$exports = {};
$0a1b42c97638052f$exports = {
  "loading": "Laadimine...",
  "loadingMore": "Laadi rohkem..."
};
var $177331a39d162ddc$exports = {};
$177331a39d162ddc$exports = {
  "loading": "Ladataan\u2026",
  "loadingMore": "Ladataan lis\xE4\xE4\u2026"
};
var $273b1d5ecf07fe52$exports = {};
$273b1d5ecf07fe52$exports = {
  "loading": "Chargement...",
  "loadingMore": "Chargement suppl\xE9mentaire..."
};
var $459441d19cfa90a8$exports = {};
$459441d19cfa90a8$exports = {
  "loading": "\u05D8\u05D5\u05E2\u05DF...",
  "loadingMore": "\u05D8\u05D5\u05E2\u05DF \u05E2\u05D5\u05D3..."
};
var $c30474fbd65b2878$exports = {};
$c30474fbd65b2878$exports = {
  "loading": "U\u010Ditavam...",
  "loadingMore": "U\u010Ditavam jo\u0161..."
};
var $fd19cc1d41a750e5$exports = {};
$fd19cc1d41a750e5$exports = {
  "loading": "Bet\xF6lt\xE9s folyamatban\u2026",
  "loadingMore": "Tov\xE1bbiak bet\xF6lt\xE9se folyamatban\u2026"
};
var $158d0aece262406d$exports = {};
$158d0aece262406d$exports = {
  "loading": "Caricamento...",
  "loadingMore": "Caricamento altri..."
};
var $bc830316669a23f8$exports = {};
$bc830316669a23f8$exports = {
  "loading": "\u8AAD\u307F\u8FBC\u307F\u4E2D...",
  "loadingMore": "\u3055\u3089\u306B\u8AAD\u307F\u8FBC\u307F\u4E2D..."
};
var $7fa23663d4de476d$exports = {};
$7fa23663d4de476d$exports = {
  "loading": "\uB85C\uB4DC \uC911",
  "loadingMore": "\uCD94\uAC00 \uB85C\uB4DC \uC911"
};
var $827e42814bc8f58e$exports = {};
$827e42814bc8f58e$exports = {
  "loading": "\u012Ekeliama...",
  "loadingMore": "\u012Ekeliama daugiau..."
};
var $6ca653959481d2db$exports = {};
$6ca653959481d2db$exports = {
  "loading": "Notiek iel\u0101de...",
  "loadingMore": "Tiek iel\u0101d\u0113ts v\u0113l..."
};
var $9efb74877777657a$exports = {};
$9efb74877777657a$exports = {
  "loading": "Laster inn ...",
  "loadingMore": "Laster inn flere ..."
};
var $d085d780952864a7$exports = {};
$d085d780952864a7$exports = {
  "loading": "Laden...",
  "loadingMore": "Meer laden..."
};
var $c207a8811c9791e9$exports = {};
$c207a8811c9791e9$exports = {
  "loading": "\u0141adowanie...",
  "loadingMore": "Wczytywanie wi\u0119kszej liczby..."
};
var $eda3511d3b2e0e51$exports = {};
$eda3511d3b2e0e51$exports = {
  "loading": "Carregando...",
  "loadingMore": "Carregando mais..."
};
var $a9c1da319e5254cb$exports = {};
$a9c1da319e5254cb$exports = {
  "loading": "A carregar...",
  "loadingMore": "A carregar mais..."
};
var $bc5c688ddc9e69fb$exports = {};
$bc5c688ddc9e69fb$exports = {
  "loading": "Se \xEEncarc\u0103...",
  "loadingMore": "Se \xEEncarc\u0103 mai multe..."
};
var $84ec40785c299370$exports = {};
$84ec40785c299370$exports = {
  "loading": "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430...",
  "loadingMore": "\u0414\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u0430\u044F \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0430..."
};
var $510ebbcbf8f3c784$exports = {};
$510ebbcbf8f3c784$exports = {
  "loading": "Na\u010D\xEDtava sa...",
  "loadingMore": "Na\u010D\xEDtava sa viac..."
};
var $49f018934e6f92c2$exports = {};
$49f018934e6f92c2$exports = {
  "loading": "Nalaganje...",
  "loadingMore": "Nalaganje ve\u010D vsebine..."
};
var $7513a1b075b503d5$exports = {};
$7513a1b075b503d5$exports = {
  "loading": "U\u010Ditavam...",
  "loadingMore": "U\u010Ditavam jo\u0161..."
};
var $02c92e5e0c81f9a9$exports = {};
$02c92e5e0c81f9a9$exports = {
  "loading": "L\xE4ser in...",
  "loadingMore": "L\xE4ser in mer..."
};
var $8165adf786eb9d46$exports = {};
$8165adf786eb9d46$exports = {
  "loading": "Y\xFCkleniyor...",
  "loadingMore": "Daha fazla y\xFCkleniyor..."
};
var $228238165c1367ae$exports = {};
$228238165c1367ae$exports = {
  "loading": "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F\u2026",
  "loadingMore": "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0456\u043D\u0448\u0438\u0445 \u043E\u0431\u2019\u0454\u043A\u0442\u0456\u0432..."
};
var $cc82b5cf91ddc409$exports = {};
$cc82b5cf91ddc409$exports = {
  "loading": "\u6B63\u5728\u52A0\u8F7D...",
  "loadingMore": "\u6B63\u5728\u52A0\u8F7D\u66F4\u591A..."
};
var $c1545fe26f1d3e20$exports = {};
$c1545fe26f1d3e20$exports = {
  "loading": "\u6B63\u5728\u8F09\u5165",
  "loadingMore": "\u6B63\u5728\u8F09\u5165\u66F4\u591A\u2026"
};
$07d5971c39cb246a$exports = {
  "ar-AE": $067dbd0c037ad155$exports,
  "bg-BG": $6ee4da2747de1e02$exports,
  "cs-CZ": $b58a7d965b7aa1b3$exports,
  "da-DK": $ecaca51f024191b0$exports,
  "de-DE": $6e434aa373f128b4$exports,
  "el-GR": $ddbe45fb199df913$exports,
  "en-US": $2083b83b84266bb4$exports,
  "es-ES": $a41434a97f5222d7$exports,
  "et-EE": $0a1b42c97638052f$exports,
  "fi-FI": $177331a39d162ddc$exports,
  "fr-FR": $273b1d5ecf07fe52$exports,
  "he-IL": $459441d19cfa90a8$exports,
  "hr-HR": $c30474fbd65b2878$exports,
  "hu-HU": $fd19cc1d41a750e5$exports,
  "it-IT": $158d0aece262406d$exports,
  "ja-JP": $bc830316669a23f8$exports,
  "ko-KR": $7fa23663d4de476d$exports,
  "lt-LT": $827e42814bc8f58e$exports,
  "lv-LV": $6ca653959481d2db$exports,
  "nb-NO": $9efb74877777657a$exports,
  "nl-NL": $d085d780952864a7$exports,
  "pl-PL": $c207a8811c9791e9$exports,
  "pt-BR": $eda3511d3b2e0e51$exports,
  "pt-PT": $a9c1da319e5254cb$exports,
  "ro-RO": $bc5c688ddc9e69fb$exports,
  "ru-RU": $84ec40785c299370$exports,
  "sk-SK": $510ebbcbf8f3c784$exports,
  "sl-SI": $49f018934e6f92c2$exports,
  "sr-SP": $7513a1b075b503d5$exports,
  "sv-SE": $02c92e5e0c81f9a9$exports,
  "tr-TR": $8165adf786eb9d46$exports,
  "uk-UA": $228238165c1367ae$exports,
  "zh-CN": $cc82b5cf91ddc409$exports,
  "zh-TW": $c1545fe26f1d3e20$exports
};
var $0c6f792811e33483$export$7ff8f37d2d81a48d = $j8tbs$react.createContext(null);
var $286d1cb34bb7dc84$exports = {};
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Menu-popover", function () {
  return $286d1cb34bb7dc84$export$d959f30786125b;
}, function (v) {
  return $286d1cb34bb7dc84$export$d959f30786125b = v;
});
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Menu", function () {
  return $286d1cb34bb7dc84$export$fae6af6decd50ac5;
}, function (v) {
  return $286d1cb34bb7dc84$export$fae6af6decd50ac5 = v;
});
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Menu-sectionHeading", function () {
  return $286d1cb34bb7dc84$export$c20ea4b35020fbdd;
}, function (v) {
  return $286d1cb34bb7dc84$export$c20ea4b35020fbdd = v;
});
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Menu-checkmark", function () {
  return $286d1cb34bb7dc84$export$8e15a726e4f7e62d;
}, function (v) {
  return $286d1cb34bb7dc84$export$8e15a726e4f7e62d = v;
});
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Menu-item", function () {
  return $286d1cb34bb7dc84$export$45faad328e6c532b;
}, function (v) {
  return $286d1cb34bb7dc84$export$45faad328e6c532b = v;
});
$parcel$export($286d1cb34bb7dc84$exports, "is-selected", function () {
  return $286d1cb34bb7dc84$export$1e0fb04f31d3c22a;
}, function (v) {
  return $286d1cb34bb7dc84$export$1e0fb04f31d3c22a = v;
});
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Icon", function () {
  return $286d1cb34bb7dc84$export$d374b04f30360026;
}, function (v) {
  return $286d1cb34bb7dc84$export$d374b04f30360026 = v;
});
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Menu-itemLabel", function () {
  return $286d1cb34bb7dc84$export$1aa6419c5c650567;
}, function (v) {
  return $286d1cb34bb7dc84$export$1aa6419c5c650567 = v;
});
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Menu-itemIcon", function () {
  return $286d1cb34bb7dc84$export$f431001e1bb54633;
}, function (v) {
  return $286d1cb34bb7dc84$export$f431001e1bb54633 = v;
});
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Menu-itemLabel--wrapping", function () {
  return $286d1cb34bb7dc84$export$465092164a8e1d98;
}, function (v) {
  return $286d1cb34bb7dc84$export$465092164a8e1d98 = v;
});
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Menu-divider", function () {
  return $286d1cb34bb7dc84$export$e892026f534efed8;
}, function (v) {
  return $286d1cb34bb7dc84$export$e892026f534efed8 = v;
});
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Menu-itemGrid", function () {
  return $286d1cb34bb7dc84$export$ee5f52784f57f9c8;
}, function (v) {
  return $286d1cb34bb7dc84$export$ee5f52784f57f9c8 = v;
});
$parcel$export($286d1cb34bb7dc84$exports, "is-selectable", function () {
  return $286d1cb34bb7dc84$export$fbd22ba224473193;
}, function (v) {
  return $286d1cb34bb7dc84$export$fbd22ba224473193 = v;
});
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Menu-end", function () {
  return $286d1cb34bb7dc84$export$926a1bb74ed65667;
}, function (v) {
  return $286d1cb34bb7dc84$export$926a1bb74ed65667 = v;
});
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Menu-icon", function () {
  return $286d1cb34bb7dc84$export$cbbae63ef9e44c7a;
}, function (v) {
  return $286d1cb34bb7dc84$export$cbbae63ef9e44c7a = v;
});
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Menu-description", function () {
  return $286d1cb34bb7dc84$export$36f1275051e39ead;
}, function (v) {
  return $286d1cb34bb7dc84$export$36f1275051e39ead = v;
});
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Menu-keyboard", function () {
  return $286d1cb34bb7dc84$export$4f9817a7dff6ba0f;
}, function (v) {
  return $286d1cb34bb7dc84$export$4f9817a7dff6ba0f = v;
});
$parcel$export($286d1cb34bb7dc84$exports, "focus-ring", function () {
  return $286d1cb34bb7dc84$export$f39a09f249340e2a;
}, function (v) {
  return $286d1cb34bb7dc84$export$f39a09f249340e2a = v;
});
$parcel$export($286d1cb34bb7dc84$exports, "is-focused", function () {
  return $286d1cb34bb7dc84$export$e7dc768d35940237;
}, function (v) {
  return $286d1cb34bb7dc84$export$e7dc768d35940237 = v;
});
$parcel$export($286d1cb34bb7dc84$exports, "is-hovered", function () {
  return $286d1cb34bb7dc84$export$b8813cd5d7824ce7;
}, function (v) {
  return $286d1cb34bb7dc84$export$b8813cd5d7824ce7 = v;
});
$parcel$export($286d1cb34bb7dc84$exports, "is-highlighted", function () {
  return $286d1cb34bb7dc84$export$451c613d0772eb99;
}, function (v) {
  return $286d1cb34bb7dc84$export$451c613d0772eb99 = v;
});
$parcel$export($286d1cb34bb7dc84$exports, "is-open", function () {
  return $286d1cb34bb7dc84$export$a9781837241c946d;
}, function (v) {
  return $286d1cb34bb7dc84$export$a9781837241c946d = v;
});
$parcel$export($286d1cb34bb7dc84$exports, "is-active", function () {
  return $286d1cb34bb7dc84$export$20fd0f7cd4e6112f;
}, function (v) {
  return $286d1cb34bb7dc84$export$20fd0f7cd4e6112f = v;
});
$parcel$export($286d1cb34bb7dc84$exports, "is-disabled", function () {
  return $286d1cb34bb7dc84$export$d35bc1e505d1ebbf;
}, function (v) {
  return $286d1cb34bb7dc84$export$d35bc1e505d1ebbf = v;
});
var $286d1cb34bb7dc84$export$d959f30786125b;
var $286d1cb34bb7dc84$export$fae6af6decd50ac5;
var $286d1cb34bb7dc84$export$c20ea4b35020fbdd;
var $286d1cb34bb7dc84$export$8e15a726e4f7e62d;
var $286d1cb34bb7dc84$export$45faad328e6c532b;
var $286d1cb34bb7dc84$export$1e0fb04f31d3c22a;
var $286d1cb34bb7dc84$export$d374b04f30360026;
var $286d1cb34bb7dc84$export$1aa6419c5c650567;
var $286d1cb34bb7dc84$export$f431001e1bb54633;
var $286d1cb34bb7dc84$export$465092164a8e1d98;
var $286d1cb34bb7dc84$export$e892026f534efed8;
var $286d1cb34bb7dc84$export$ee5f52784f57f9c8;
var $286d1cb34bb7dc84$export$fbd22ba224473193;
var $286d1cb34bb7dc84$export$926a1bb74ed65667;
var $286d1cb34bb7dc84$export$cbbae63ef9e44c7a;
var $286d1cb34bb7dc84$export$36f1275051e39ead;
var $286d1cb34bb7dc84$export$4f9817a7dff6ba0f;
var $286d1cb34bb7dc84$export$f39a09f249340e2a;
var $286d1cb34bb7dc84$export$e7dc768d35940237;
var $286d1cb34bb7dc84$export$b8813cd5d7824ce7;
var $286d1cb34bb7dc84$export$451c613d0772eb99;
var $286d1cb34bb7dc84$export$a9781837241c946d;
var $286d1cb34bb7dc84$export$20fd0f7cd4e6112f;
var $286d1cb34bb7dc84$export$d35bc1e505d1ebbf;
$286d1cb34bb7dc84$export$d959f30786125b = "spectrum-Menu-popover_7ea47c";
$286d1cb34bb7dc84$export$fae6af6decd50ac5 = "spectrum-Menu_7ea47c";
$286d1cb34bb7dc84$export$c20ea4b35020fbdd = "spectrum-Menu-sectionHeading_7ea47c";
$286d1cb34bb7dc84$export$8e15a726e4f7e62d = "spectrum-Menu-checkmark_7ea47c";
$286d1cb34bb7dc84$export$45faad328e6c532b = "spectrum-Menu-item_7ea47c";
$286d1cb34bb7dc84$export$1e0fb04f31d3c22a = "is-selected_7ea47c";
$286d1cb34bb7dc84$export$d374b04f30360026 = "spectrum-Icon_7ea47c";
$286d1cb34bb7dc84$export$1aa6419c5c650567 = "spectrum-Menu-itemLabel_7ea47c";
$286d1cb34bb7dc84$export$f431001e1bb54633 = "spectrum-Menu-itemIcon_7ea47c";
$286d1cb34bb7dc84$export$465092164a8e1d98 = "spectrum-Menu-itemLabel--wrapping_7ea47c";
$286d1cb34bb7dc84$export$e892026f534efed8 = "spectrum-Menu-divider_7ea47c";
$286d1cb34bb7dc84$export$ee5f52784f57f9c8 = "spectrum-Menu-itemGrid_7ea47c";
$286d1cb34bb7dc84$export$fbd22ba224473193 = "is-selectable_7ea47c";
$286d1cb34bb7dc84$export$926a1bb74ed65667 = "spectrum-Menu-end_7ea47c";
$286d1cb34bb7dc84$export$cbbae63ef9e44c7a = "spectrum-Menu-icon_7ea47c";
$286d1cb34bb7dc84$export$36f1275051e39ead = "spectrum-Menu-description_7ea47c";
$286d1cb34bb7dc84$export$4f9817a7dff6ba0f = "spectrum-Menu-keyboard_7ea47c";
$286d1cb34bb7dc84$export$f39a09f249340e2a = "focus-ring_7ea47c";
$286d1cb34bb7dc84$export$e7dc768d35940237 = "is-focused_7ea47c";
$286d1cb34bb7dc84$export$b8813cd5d7824ce7 = "is-hovered_7ea47c";
$286d1cb34bb7dc84$export$451c613d0772eb99 = "is-highlighted_7ea47c";
$286d1cb34bb7dc84$export$a9781837241c946d = "is-open_7ea47c";
$286d1cb34bb7dc84$export$20fd0f7cd4e6112f = "is-active_7ea47c";
$286d1cb34bb7dc84$export$d35bc1e505d1ebbf = "is-disabled_7ea47c";
function $86983ea1fa3f7312$export$feb3b6b552c14a12(props) {
  var item = props.item,
    shouldSelectOnPressUp = props.shouldSelectOnPressUp,
    shouldFocusOnHover = props.shouldFocusOnHover,
    shouldUseVirtualFocus = props.shouldUseVirtualFocus;
  var rendered = item.rendered,
    key = item.key;
  var state = $j8tbs$useContext($0c6f792811e33483$export$7ff8f37d2d81a48d);
  var ref = $j8tbs$useRef();
  var _$j8tbs$useOption = $j8tbs$useOption({
      'aria-label': item['aria-label'],
      key: key,
      shouldSelectOnPressUp: shouldSelectOnPressUp,
      shouldFocusOnHover: shouldFocusOnHover,
      isVirtualized: true,
      shouldUseVirtualFocus: shouldUseVirtualFocus
    }, state, ref),
    optionProps = _$j8tbs$useOption.optionProps,
    labelProps = _$j8tbs$useOption.labelProps,
    descriptionProps = _$j8tbs$useOption.descriptionProps,
    isSelected = _$j8tbs$useOption.isSelected,
    isDisabled = _$j8tbs$useOption.isDisabled,
    isFocused = _$j8tbs$useOption.isFocused;
  var _$j8tbs$useHover = $j8tbs$useHover(_objectSpread(_objectSpread({}, props), {}, {
      isDisabled: isDisabled
    })),
    hoverProps = _$j8tbs$useHover.hoverProps,
    isHovered = _$j8tbs$useHover.isHovered;
  var contents = typeof rendered === 'string' ? /*#__PURE__*/$j8tbs$react.createElement($j8tbs$Text, null, rendered) : rendered;
  var isKeyboardModality = $j8tbs$isFocusVisible();
  return /*#__PURE__*/$j8tbs$react.createElement($j8tbs$FocusRing, {
    focusRingClass: $j8tbs$classNames( /*@__PURE__*/$parcel$interopDefault($286d1cb34bb7dc84$exports), 'focus-ring')
  }, /*#__PURE__*/$j8tbs$react.createElement("div", _objectSpread(_objectSpread({}, $j8tbs$mergeProps(optionProps, shouldFocusOnHover ? {} : hoverProps)), {}, {
    ref: ref,
    className: $j8tbs$classNames( /*@__PURE__*/$parcel$interopDefault($286d1cb34bb7dc84$exports), 'spectrum-Menu-item', {
      // If using virtual focus, apply focused styles to the item when the user is interacting with keyboard modality
      'is-focused': shouldUseVirtualFocus && isFocused && isKeyboardModality,
      'is-disabled': isDisabled,
      'is-selected': isSelected,
      'is-selectable': state.selectionManager.selectionMode !== 'none',
      // When shouldFocusOnHover is false, apply hover styles both when hovered with the mouse.
      // Otherwise, apply hover styles when focused using non-keyboard modality.
      'is-hovered': isHovered && !shouldFocusOnHover || isFocused && !isKeyboardModality
    })
  }), /*#__PURE__*/$j8tbs$react.createElement($j8tbs$Grid, {
    UNSAFE_className: $j8tbs$classNames( /*@__PURE__*/$parcel$interopDefault($286d1cb34bb7dc84$exports), 'spectrum-Menu-itemGrid')
  }, /*#__PURE__*/$j8tbs$react.createElement($j8tbs$ClearSlots, null, /*#__PURE__*/$j8tbs$react.createElement($j8tbs$SlotProvider, {
    slots: {
      text: _objectSpread({
        UNSAFE_className: /*@__PURE__*/$parcel$interopDefault($286d1cb34bb7dc84$exports)['spectrum-Menu-itemLabel']
      }, labelProps),
      icon: {
        size: 'S',
        UNSAFE_className: /*@__PURE__*/$parcel$interopDefault($286d1cb34bb7dc84$exports)['spectrum-Menu-icon']
      },
      description: _objectSpread({
        UNSAFE_className: /*@__PURE__*/$parcel$interopDefault($286d1cb34bb7dc84$exports)['spectrum-Menu-description']
      }, descriptionProps)
    }
  }, contents, isSelected && /*#__PURE__*/$j8tbs$react.createElement($j8tbs$spectrumiconsuiCheckmarkMedium, {
    slot: "checkmark",
    UNSAFE_className: $j8tbs$classNames( /*@__PURE__*/$parcel$interopDefault($286d1cb34bb7dc84$exports), 'spectrum-Menu-checkmark')
  }))))));
}
function $92d678ed88836094$export$dca12b0bb56e4fc(props) {
  var children = props.children,
    reusableView = props.reusableView,
    header = props.header;
  var item = reusableView.content;
  var _$j8tbs$useListBoxSec = $j8tbs$useListBoxSection({
      heading: item.rendered,
      'aria-label': item['aria-label']
    }),
    headingProps = _$j8tbs$useListBoxSec.headingProps,
    groupProps = _$j8tbs$useListBoxSec.groupProps;
  var _$j8tbs$useSeparator = $j8tbs$useSeparator({
      elementType: 'li'
    }),
    separatorProps = _$j8tbs$useSeparator.separatorProps;
  var headerRef = $j8tbs$useRef();
  $j8tbs$useVirtualizerItem({
    reusableView: header,
    ref: headerRef
  });
  var _$j8tbs$useLocale = $j8tbs$useLocale(),
    direction = _$j8tbs$useLocale.direction;
  var state = $j8tbs$useContext($0c6f792811e33483$export$7ff8f37d2d81a48d);
  return /*#__PURE__*/$j8tbs$react.createElement($j8tbs$Fragment, null, /*#__PURE__*/$j8tbs$react.createElement("div", {
    role: "presentation",
    ref: headerRef,
    style: $j8tbs$layoutInfoToStyle(header.layoutInfo, direction)
  }, item.key !== state.collection.getFirstKey() && /*#__PURE__*/$j8tbs$react.createElement("div", _objectSpread(_objectSpread({}, separatorProps), {}, {
    className: $j8tbs$classNames( /*@__PURE__*/$parcel$interopDefault($286d1cb34bb7dc84$exports), 'spectrum-Menu-divider')
  })), item.rendered && /*#__PURE__*/$j8tbs$react.createElement("div", _objectSpread(_objectSpread({}, headingProps), {}, {
    className: $j8tbs$classNames( /*@__PURE__*/$parcel$interopDefault($286d1cb34bb7dc84$exports), 'spectrum-Menu-sectionHeading')
  }), item.rendered)), /*#__PURE__*/$j8tbs$react.createElement("div", _objectSpread(_objectSpread({}, groupProps), {}, {
    style: $j8tbs$layoutInfoToStyle(reusableView.layoutInfo, direction),
    className: $j8tbs$classNames( /*@__PURE__*/$parcel$interopDefault($286d1cb34bb7dc84$exports), 'spectrum-Menu')
  }), children));
}
function $3247d4a89e6094e9$export$25768ea656ae32a7(state) {
  var _$j8tbs$useProvider = $j8tbs$useProvider(),
    scale = _$j8tbs$useProvider.scale;
  var collator = $j8tbs$useCollator({
    usage: 'search',
    sensitivity: 'base'
  });
  var layout = $j8tbs$useMemo(function () {
    return new $j8tbs$ListLayout({
      estimatedRowHeight: scale === 'large' ? 48 : 32,
      estimatedHeadingHeight: scale === 'large' ? 33 : 26,
      padding: scale === 'large' ? 5 : 4,
      loaderHeight: 40,
      placeholderHeight: scale === 'large' ? 48 : 32,
      collator: collator
    });
  }, [collator, scale]);
  layout.collection = state.collection;
  layout.disabledKeys = state.disabledKeys;
  return layout;
}
/** @private */
function $3247d4a89e6094e9$var$ListBoxBase(props, ref) {
  var layout = props.layout,
    state = props.state,
    shouldSelectOnPressUp = props.shouldSelectOnPressUp,
    focusOnPointerEnter = props.focusOnPointerEnter,
    shouldUseVirtualFocus = props.shouldUseVirtualFocus,
    _props$domProps = props.domProps,
    domProps = _props$domProps === void 0 ? {} : _props$domProps,
    _props$transitionDura = props.transitionDuration,
    transitionDuration = _props$transitionDura === void 0 ? 0 : _props$transitionDura,
    onScroll = props.onScroll;
  var _$j8tbs$useListBox = $j8tbs$useListBox(_objectSpread(_objectSpread({}, props), {}, {
      keyboardDelegate: layout,
      isVirtualized: true
    }), state, ref),
    listBoxProps = _$j8tbs$useListBox.listBoxProps;
  var _$j8tbs$useStyleProps = $j8tbs$useStyleProps(props),
    styleProps = _$j8tbs$useStyleProps.styleProps;
  var stringFormatter = $j8tbs$useLocalizedStringFormatter( /*@__PURE__*/$parcel$interopDefault($07d5971c39cb246a$exports));
  // Sync loading state into the layout.
  layout.isLoading = props.isLoading;
  var renderWrapper = function renderWrapper(parent, reusableView, children, renderChildren) {
    if (reusableView.viewType === 'section') return /*#__PURE__*/$j8tbs$react.createElement($92d678ed88836094$export$dca12b0bb56e4fc, {
      key: reusableView.key,
      reusableView: reusableView,
      header: children.find(function (c) {
        return c.viewType === 'header';
      })
    }, renderChildren(children.filter(function (c) {
      return c.viewType === 'item';
    })));
    return /*#__PURE__*/$j8tbs$react.createElement($j8tbs$VirtualizerItem, {
      key: reusableView.key,
      reusableView: reusableView,
      parent: parent
    });
  };
  return /*#__PURE__*/$j8tbs$react.createElement($0c6f792811e33483$export$7ff8f37d2d81a48d.Provider, {
    value: state
  }, /*#__PURE__*/$j8tbs$react.createElement($j8tbs$FocusScope, null, /*#__PURE__*/$j8tbs$react.createElement($j8tbs$Virtualizer, _objectSpread(_objectSpread(_objectSpread({}, styleProps), $j8tbs$mergeProps(listBoxProps, domProps)), {}, {
    ref: ref,
    focusedKey: state.selectionManager.focusedKey,
    sizeToFit: "height",
    scrollDirection: "vertical",
    className: $j8tbs$classNames( /*@__PURE__*/$parcel$interopDefault($286d1cb34bb7dc84$exports), 'spectrum-Menu', styleProps.className),
    layout: layout,
    collection: state.collection,
    renderWrapper: renderWrapper,
    transitionDuration: transitionDuration,
    isLoading: props.isLoading,
    onLoadMore: props.onLoadMore,
    shouldUseVirtualFocus: shouldUseVirtualFocus,
    onScroll: onScroll
  }), function (type, item) {
    if (type === 'item') return /*#__PURE__*/$j8tbs$react.createElement($86983ea1fa3f7312$export$feb3b6b552c14a12, {
      item: item,
      shouldSelectOnPressUp: shouldSelectOnPressUp,
      shouldFocusOnHover: focusOnPointerEnter,
      shouldUseVirtualFocus: shouldUseVirtualFocus
    });else if (type === 'loader') return (
      // aria-selected isn't needed here since this option is not selectable.
      // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
      /*#__PURE__*/
      $j8tbs$react.createElement("div", {
        role: "option",
        style: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%'
        }
      }, /*#__PURE__*/$j8tbs$react.createElement($j8tbs$ProgressCircle, {
        isIndeterminate: true,
        size: "S",
        "aria-label": state.collection.size > 0 ? stringFormatter.format('loadingMore') : stringFormatter.format('loading'),
        UNSAFE_className: $j8tbs$classNames( /*@__PURE__*/$parcel$interopDefault($286d1cb34bb7dc84$exports), 'spectrum-Dropdown-progressCircle')
      }))
    );else if (type === 'placeholder') {
      var emptyState = props.renderEmptyState ? props.renderEmptyState() : null;
      if (emptyState == null) return null;
      return /*#__PURE__*/$j8tbs$react.createElement("div", {
        // aria-selected isn't needed here since this option is not selectable.
        // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
        role: "option"
      }, emptyState);
    }
  })));
}
// forwardRef doesn't support generic parameters, so cast the result to the correct type
// https://stackoverflow.com/questions/58469229/react-with-typescript-generics-while-using-react-forwardref
var $3247d4a89e6094e9$export$1afdcf349979fb7e = /*#__PURE__*/$j8tbs$react.forwardRef($3247d4a89e6094e9$var$ListBoxBase);
function $3136257018b1a220$var$ListBox(props, ref) {
  var state = $j8tbs$useListState(props);
  var layout = $3247d4a89e6094e9$export$25768ea656ae32a7(state);
  var domRef = $j8tbs$useDOMRef(ref);
  return /*#__PURE__*/$j8tbs$react.createElement($3247d4a89e6094e9$export$1afdcf349979fb7e, _objectSpread(_objectSpread({}, props), {}, {
    ref: domRef,
    state: state,
    layout: layout
  }));
}
// forwardRef doesn't support generic parameters, so cast the result to the correct type
// https://stackoverflow.com/questions/58469229/react-with-typescript-generics-while-using-react-forwardref
/**
 * A list of options that can allow selection of one or more.
 */
var $3136257018b1a220$export$41f133550aa26f48 = /*#__PURE__*/$j8tbs$react.forwardRef($3136257018b1a220$var$ListBox);
export { $3136257018b1a220$export$41f133550aa26f48 as ListBox, $3247d4a89e6094e9$export$25768ea656ae32a7 as useListBoxLayout, $3247d4a89e6094e9$export$1afdcf349979fb7e as ListBoxBase, $ee97ea796309b076$re_export$Item as Item, $ee97ea796309b076$re_export$Section as Section };